<template>
  <div class="tag-container">
    <div
      v-for="(group, idx) in groups"
      v-bind:key="idx"
      class="tag"
      v-bind:class="getTagClass(group)"
    >
      {{ group | whitespace | titlecase }}
    </div>
  </div>
</template>
<script>
export default {
  name: "user-group-tags",
  data: function() {
    return {
      mapping: {
        instructor: "info",
        "training-pilot": "info",
        examiner: "success",
        "check-pilot": "success",
        supervisor: "link",
        administrator: "warning",
        "system-admin": "dark"
      }
    };
  },
  props: {
    groups: Array
  },
  methods: {
    getTagClass: function(group) {
      return "tag--" + this.mapping[group];
    }
  }
};
</script>
